{
  "commonHeader": {
    "upgradeToPro": "Перейти на Pro",
    "learnMore": "Подробнее",
    "AIProductivitySuite": {
      "title": "Пакет для продуктивности с ИИ",
      "desc": "Превращайте вдохновляющие обсуждения во впечатляющие результаты."
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "Управляйте учетной записью организации с помощью ИИ",
        "description": "Получайте интеллектуальные ответы на вопросы об учетной записи и помощь в навигации по настройкам.",
        "terms": "Используя бета-функции Zoom, вы соглашаетесь с {0}",
        "termsText": "Условиями бета-программы Zoom"
      },
      "diveDeeper": "Узнать больше",
      "shareFeedback": "Оставьте отзыв в {0}",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "Задайте вопрос об учетной записи организации",
      "heroInvite": "Как пригласить нового пользователя в учетную запись?",
      "heroGroups": "Как назначить пользователей в группы?",
      "heroRoles": "Как управлять ролями и разрешениями?"
    },
    "backMainAccount": "Вернуться к основной учетной записи",
    "discoverProducts": "Открыть продукты",
    "pricing": "Тарифы",
    "more": "Ещё",
    "sidebarExpanded": "развернуто",
    "sidebarCollapsed": "свернуто",
    "search": "Поиск",
    "users": "Пользователи",
    "settings": "Настройки аккаунта",
    "navigation": "Навигация",
    "clear": "Очистить",
    "searchPlaceholderAll": "Поиск пользователей, настроек учетной записи или навигации",
    "searchPlaceholderUsers": "Поиск пользователей или навигации",
    "searchPlaceholderSettings": "Поиск настроек учетной записи или навигации",
    "searchPlaceholderNav": "Поиск в навигации",
    "searchGuide": "Введите ключевые слова, чтобы начать поиск",
    "installOnDesktop": "Установить на компьютер",
    "downloadCenter": "Центр загрузок",
    "getInTouch": "Связаться с нами",
    "featuredProduct": "рекомендуемый продукт",
    "logo": {
      "adminCenter": "Центр администрирования",
      "subAccount": "Управление дополнительной учетной записью",
      "externalAccount": "Управление делегированной учетной записью"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "Подробнее",
      "gotIt": "Понятно"
    },
    "coachMark": {
      "dvsTipsTitle": "Подразделения теперь доступны",
      "dvsTipsContent": "Подразделения используются для создания нескольких экземпляров определенных продуктов Zoom в вашей учетной записи."
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "Подробнее",
      "gotIt": "Понятно"
    },
    "coachMark": {
      "extAccountTipsTitle": "Управление внешними учетными записями",
      "extAccountTipsContent": "Нужно управлять другой учетной записью? Просто отправьте запрос — после одобрения вы получите доступ!"
    }
  },
  "feedback": {
    "dialogTitle": "Оставить обратную связь",
    "itemLableForProductArea": "Категория продукта",
    "itemLableForSatisfied": "Насколько вы удовлетворены своим опытом?",
    "dissatisfied": "Очень не понравилось",
    "satisfied": "Очень понравилось",
    "itemLableForFeedback": "Обратная связь",
    "placeholder": "Благодарим вас за идеи, комментарии и предложения.",
    "btnCancel": "Отменить",
    "btnSubmit": "Отправить",
    "supportTips": "Для получения технической поддержки посетите сайт",
    "btnSupport": "Поддержка.",
    "messages": {
      "success": "Благодарим за обратную связь!",
      "productFailed": "Необходимо указать категорию продукта.",
      "scoreFailed": "Необходимо указать индекс удовлетворенности."
    },
    "products": {
      "General": "Общие",
      "AI": "ИИ",
      "Apps": "Приложения",
      "Calendar": "Календарь",
      "Clips": "Clips",
      "ContactCenter": "Contact Center",
      "Docs": "Docs",
      "Huddles": "Huddles",
      "Mail": "Почта",
      "Meetings": "Конференции",
      "Notes": "Заметки",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "Планировщик",
      "Tasks": "Задачи",
      "TeamChat": "Командный чат",
      "WebinarsAndEvents": "Вебинары и мероприятия",
      "Whiteboard": "Доска",
      "WorkflowAutomations": "Автоматизация рабочих процессов",
      "WorkspaceReservation": "Бронирование рабочих мест",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "Данный отказ от ответственности был создан администратором вашей учетной записи.",
    "cancel": "Отмена",
    "agree": "Согласен"
  },
  "shared": {
    "sideMenu": {
      "personal": "Личный",
      "admin": "Администратор",
      "menu": "Меню",
      "pinned": "Закреплено",
      "pin": "Закрепить",
      "unpin": "Открепить",
      "moveItem": "Переместить элемент",
      "myAccount": "Моя учетная запись",
      "upgradeToPro": "Перейти на Pro",
      "grabbedKeyboard": "{0} захвачен. Используйте стрелки вверх и вниз для перемещения, пробел или Enter для размещения.",
      "dropped": "{0} размещен.",
      "releasedUnchanged": "{0} отпущен, положение не изменено.",
      "movedToPosition": "{0} перемещен на позицию {1} из {2}.",
      "movedUp": "{0} перемещен вверх, позиция {1} из {2}.",
      "movedDown": "{0} перемещен вниз, позиция {1} из {2}.",
      "movedUpNew": "{0} перемещен вверх, новая позиция {1} из {2}",
      "movedDownNew": "{0} перемещен вниз, новая позиция {1} из {2}",
      "cannotMoveFurther": "{0} нельзя переместить дальше.",
      "grabbedMouse": "{0} захвачен. Переместите мышь, чтобы изменить положение, щелкните, чтобы разместить, нажмите Escape для отмены."
    },
    "item": "Элемент",
    "gotIt": "Понятно",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "Номер телефона добавлен! Теперь вы сможете использовать его для входа в систему и восстановления учетной записи.",
    "mfa_to_signin_phone_success": "Теперь для входа с {email} используется номер {phone}.",
    "login_passkey_bound_success": "Ключ доступа создан."
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "Следующие функции расширенного управления применяются только к лицензированным пользователям и участникам коллективной работы",
      "licensed_basic": "Следующие функции расширенного управления применяются только к лицензированным и базовым пользователям",
      "licensed": "Следующие функции расширенного управления применяются только к лицензированным пользователям"
    },
    "support": "- Поддержка в настройках учетной записи и настройках группы пользователей",
    "archive_product": {
      "title": "Архивация конференций и вебинаров",
      "detail": "- При подключении пользователей вашей учетной записи конференции будут добавляться в архив. Чтобы использовать этот параметр, установите <a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">приложение для архивации</a> из Zoom App Marketplace."
    },
    "restrict": {
      "title": "Запрет использования выбранных функций при подключении к конференции",
      "detail": "- Выбранные функции будут недоступны, даже если организаторы конференций включат их для своих конференций."
    },
    "meeting_integration": {
      "title": "Включение интеграции с политикой DLP (защита от потери данных) в чате конференции",
      "detail": "- Если этот параметр включен, политика защиты от потери данных (DLP) будет применяться к сообщениям как открытого, так и личного чата, отправляемым участником. Если участники конференции (внутренние/внешние) будут обмениваться сообщениями, которые противоречат политикам соответствия требованиям компании организатора, такие сообщения будут немедленно удалены."
    },
    "chat_tool": {
      "title": "Средство реализации правил поведения в чате",
      "detail": "- Выделяет в совместно используемом содержимом заданные ключевые слова и наборы слов, защищая пользователей от публикации нежелательных сообщений"
    },
    "information_barriers": {
      "title": "Информационные барьеры",
      "detail": "- Информационные барьеры управляют коммуникацией между конкретными пользователями для обеспечения соответствия требованиям. Можно настроить ограничения для конференций и чата между двумя группами пользователей, а также ограничить использование конкретными пользователями определенных функций (например, чат в конференции, демонстрация экрана и передача файлов). Эти ограничения позволяют защитить конфиденциальную информацию от передачи неавторизованным пользователям."
    },
    "dashboard": {
      "title": "Панель",
      "detail": "- Для некоторых пользователей данные раздела «Конференции» на панели прошедших конференций отображаются только за 3 месяца"
    },
    "reports": {
      "title": "Отчеты",
      "detail": "- В некоторых отчетах для некоторых пользователей отображаются данные только за 3 месяца: отчет об отказе от ответственности, отчет о журнале присутствующих, отчет о журналах действий администратора и отчет о входах и выходах"
    },
    "close": "Закрыть"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "План {planName} будет отменен {cancelDate}. До этой даты можно повторно активировать лицензии на вебинары. С {supportStartDate} по {supportEndDate} вы можете обратиться в службу поддержки клиентов, чтобы получить существующие данные вебинаров. После {dataLossDate} они будут утрачены.",
            "nonAdmin": "План {planName} будет отменен {cancelDate}. Свяжитесь с администратором учетной записи до этой даты, чтобы повторно активировать лицензии на вебинары. С {supportStartDate} по {supportEndDate} вы можете обратиться в службу поддержки клиентов, чтобы получить существующие данные вебинаров. После {dataLossDate} все данные вебинаров в учетной записи будут утеряны."
          },
          "admin": "План {planName} будет отменен {cancelDate}. До этой даты можно повторно активировать лицензии на вебинары. С {supportStartDate} по {supportEndDate} вы можете обратиться в службу поддержки клиентов, чтобы получить существующие {supportContent} вебинаров. После {dataLossDate} все данные вебинаров в учетной записи будут утеряны.",
          "nonAdmin": "План {planName} будет отменен {cancelDate}. Свяжитесь с администратором учетной записи до этой даты, чтобы повторно активировать лицензии на вебинары. С {supportStartDate} по {supportEndDate} вы можете обратиться в службу поддержки клиентов, чтобы получить существующие {supportContent} вебинаров. После {dataLossDate} все данные вебинаров в учетной записи будут утеряны."
        },
        "expired": {
          "admin": "План {planName} отменен. С {supportStartDate} по {supportEndDate} вы можете связаться со службой поддержки клиентов, чтобы получить существующие {supportContent} вебинаров, или снова приобрести Zoom Webinars для восстановления доступа к данным. После {dataLossDate} все данные вебинаров в учетной записи будут утеряны.",
          "nonAdmin": "План {planName} отменен. С {supportStartDate} по {supportEndDate} вы можете связаться со службой поддержки клиентов, чтобы получить существующие {supportContent} вебинаров, или с администратором учетной записи, чтобы снова приобрести Zoom Webinars и восстановить доступ к данным. После {dataLossDate} все данные вебинаров в учетной записи будут утеряны."
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "План {planName} будет приостановлен {pausedDate} на {pauseDuration}. В этот период можно только просматривать существующие вебинары и их ресурсы. Вы можете возобновить действие плана и лицензий на вебинары в любое время.",
            "nonAdmin": "План {planName} будет приостановлен {pausedDate} на {pauseDuration}. В этот период можно только просматривать существующие вебинары и их ресурсы. Свяжитесь с администратором вашей учетной записи, чтобы отменить приостановку и возобновить действие лицензий на вебинары в любое время."
          },
          "admin": "План {planName} будет приостановлен {pausedDate} на {pauseDuration}. В этот период можно только просматривать {supportContent}. Вы можете возобновить действие плана и лицензий на вебинары в любое время.",
          "nonAdmin": "План {planName} будет приостановлен {pausedDate} на {pauseDuration}. В этот период можно только просматривать {supportContent}. Свяжитесь с администратором вашей учетной записи, чтобы отменить приостановку и возобновить действие лицензий на вебинары в любое время."
        },
        "active": {
          "webinars": {
            "admin": "План {planName} приостановлен на {pauseDuration} с {pausedDate}. В этот период можно только просматривать существующие вебинары. Вы можете возобновить действие лицензий на вебинары в любое время.",
            "nonAdmin": "План {planName} приостановлен на {pauseDuration} с {pausedDate}. В этот период можно только просматривать существующие вебинары. Свяжитесь с администратором учетной записи, чтобы возобновить действие лицензий на вебинары в любое время."
          },
          "admin": "План {planName} приостановлен на {pauseDuration}. В этот период можно только просматривать существующие {supportContent} вебинаров. Вы можете возобновить действие лицензий на вебинары в любое время.",
          "nonAdmin": "План {planName} приостановлен на {pauseDuration}. В этот период можно только просматривать существующие {supportContent} вебинаров. Свяжитесь с администратором учетной записи, чтобы возобновить действие лицензий на вебинары в любое время."
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "Лицензия {planName} будет приостановлена {pausedDate} на {pauseDuration}. Чтобы продолжать проводить вебинары, назначьте активную лицензию этому пользователю до того, как приостановка вступит в силу. Вы также можете отменить приостановку, чтобы продолжить использовать эту лицензию.",
            "nonAdmin": "Лицензия {planName} будет приостановлена {pausedDate} на {pauseDuration}. В этот период можно только просматривать существующие вебинары и их ресурсы. Чтобы продолжить проводить вебинары, обратитесь к администратору учетной записи, чтобы он назначил активную лицензию для вашей учетной записи до начала приостановки."
          },
          "active": {
            "admin": "Лицензия {planName} приостановлена на {pauseDuration} с {pausedDate}. В этот период можно только просматривать существующие вебинары. Вы можете возобновить подписку на лицензию или назначить активную лицензию своей учетной записи, чтобы продолжить организовывать вебинары.",
            "nonAdmin": "Лицензия {planName} приостановлена на {pauseDuration} с {pausedDate}. В этот период можно только просматривать существующие вебинары. Чтобы организовывать вебинары во время приостановки, обратитесь к администратору учетной записи, чтобы он назначил вашей учетной записи активную лицензию."
          }
        },
        "cancel": {
          "active": {
            "admin": "Лицензия {planName} будет отменена {cancelDate}. Чтобы продолжить проведение вебинаров, повторно активируйте лицензию на вебинары или назначьте активную лицензию до вступления отмены в силу. Если никаких действий не будет предпринято, с {supportStartDate} по {supportEndDate} у вас будет льготный период, чтобы обратиться в службу поддержки клиентов и получить существующие данные вебинаров. После {dataLossDate} все данные вебинаров, связанные с вашей учетной записью, будут безвозвратно удалены.",
            "nonAdmin": "Лицензия {planName} будет отменена {cancelDate}. Чтобы продолжить проведение вебинаров, свяжитесь с администратором учетной записи, чтобы повторно активировать лицензию на вебинары или назначить активную лицензию до вступления отмены в силу. Если никаких действий не будет предпринято, с {supportStartDate} по {supportEndDate} у вас будет льготный период, чтобы обратиться в службу поддержки клиентов и получить существующие данные вебинаров. После {dataLossDate} все данные вебинаров, связанные с вашей учетной записью, будут безвозвратно удалены."
          },
          "expired": {
            "admin": "Лицензия {planName} отменена. Чтобы продолжить проводить вебинары, назначьте этому пользователю активную лицензию. С {supportStartDate} по {supportEndDate} можно обратиться в службу поддержки клиентов, чтобы получить существующие данные вебинаров.",
            "nonAdmin": "Лицензия {planName} отменена. Чтобы продолжить проводить вебинары, обратитесь к администратору учетной записи, чтобы он назначил активную лицензию для вашего профиля. С {supportStartDate} по {supportEndDate} вы можете обратиться в службу поддержки клиентов и получить существующие данные вебинаров."
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "Лицензия {planName} будет приостановлена {pausedDate} на {pauseDuration}. В этот период можно только просматривать {supportContent} прошедших вебинаров. Чтобы сохранить доступ к ресурсам вебинаров, назначьте этому пользователю активную лицензию до вступления приостановки в силу. Вы также можете отменить приостановку, чтобы продолжить использовать эту лицензию.",
              "nonAdmin": "Лицензия {planName} будет приостановлена {pausedDate} на {pauseDuration}. В этот период можно только просматривать {supportContent}. Чтобы сохранить доступ к ресурсам вебинаров, обратитесь к администратору учетной записи, чтобы он назначил вашему профилю активную лицензию."
            },
            "active": {
              "admin": "План {planName} приостановлен на {pauseDuration} с {pausedDate}. В этот период можно только просматривать {supportContent} существующих вебинаров. Чтобы сохранить доступ к ресурсам вебинаров, назначьте активную лицензию своей учетной записи. Вы также можете возобновить подписку на эту лицензию в любое время.",
              "nonAdmin": "План {planName} приостановлен на {pauseDuration} с {pausedDate}. В этот период можно только просматривать {supportContent} существующих вебинаров. Чтобы организовывать вебинары во время приостановки, обратитесь к администратору учетной записи, чтобы он назначил вашей учетной записи активную лицензию."
            }
          },
          "cancel": {
            "active": {
              "admin": "План {planName} будет отменен {cancelDate}. Чтобы продолжить проводить вебинары, назначьте активную лицензию своей учетной записи до того, как отмена вступит в силу. Вы можете повторно активировать эту лицензию до {cancelDate}. С {supportStartDate} по {supportEndDate} можно обратиться в службу поддержки клиентов, чтобы получить {supportContent} существующих вебинаров.",
              "nonAdmin": "Лицензия {planName} будет отменена {cancelDate}. Чтобы продолжить проведение вебинаров, свяжитесь с администратором учетной записи, чтобы повторно активировать лицензию на вебинары или назначить активную лицензию до вступления отмены в силу. Если никаких действий не будет предпринято, с {supportStartDate} по {supportEndDate} у вас будет льготный период, чтобы обратиться в службу поддержки клиентов и получить {supportContent} существующих вебинаров. После {dataLossDate} все данные вебинаров, связанные с вашей учетной записью, будут безвозвратно удалены."
            },
            "expired": {
              "admin": "Лицензия {planName} отменена. Чтобы продолжить проводить вебинары, назначьте этому пользователю активную лицензию. С {supportStartDate} по {supportEndDate} обратитесь в службу поддержки клиентов, чтобы получить {supportContent} существующих вебинаров.",
              "nonAdmin": "Лицензия {planName} отменена. Чтобы продолжить проводить вебинары, обратитесь к администратору учетной записи, чтобы он назначил активную лицензию для вашего профиля. С {supportStartDate} по {supportEndDate} обратитесь в службу поддержки клиентов, чтобы получить {supportContent} существующих вебинаров."
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "данные",
        "recordingsAndTranscripts": "записи и расшифровки",
        "reports": "отчеты",
        "summaries": "сводки",
        "dashboard": "панели управления"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "записи и расшифровки предыдущих вебинаров",
          "reports": "отчеты о предыдущих вебинарах",
          "summaries": "сводки предыдущих вебинаров",
          "dashboard": "панели управления предыдущих вебинаров",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "Повторно активировать план",
    "purchasePlan": "Купить план",
    "removePause": "Возобновить",
    "resumeSubscription": "Возобновить подписку",
    "month": "месяц",
    "months": "мес.",
    "assignLicense": "Назначить лицензию"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "Понятно"
    },
    "coachMark": {
      "tipsTitle": "Адресная книга станет Каталогом клиентов",
      "tipsContent": "В выпуске за октябрь 2026 года мы переименуем Адресную книгу в Каталог клиентов, чтобы точнее отразить ее назначение. Все существующие функции, разрешения и рабочие процессы останутся прежними — вы по-прежнему будете управлять списками клиентов (адресными книгами) и контактами так же, как и сейчас."
    }
  },
  "zoomPrivacy": {
    "agreeMain": "Мы обновляем наши условия и политику",
    "agreeSub": "Продолжая использовать Zoom, вы автоматически принимаете обновленные <a href=\"https://www.zoom.us/terms\" target=\"_blank\">Условия предоставления услуг</a> и <a href=\"https://www.zoom.us/privacy\" target=\"_blank\">Политику конфиденциальности</a>.",
    "continue": "Продолжить"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "Вернуться к основной учетной записи",
      "backLinkedAccount": "Вернуться к связанной учетной записи",
      "backMyAccount": "Вернуться в «Моя учетная запись»",
      "myAccount": "Моя учетная запись"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "Custom AI Companion теперь доступен для вашей учетной записи",
      "desc": "Вот некоторые функции Custom AI Companion, которые можно использовать в вашей учетной записи:",
      "studioTitle": "AI Studio",
      "studioDesc": "Настройте возможности AI Companion для вашей организации.",
      "integrationsTitle": "Сторонние интеграции",
      "integrationsDesc": "Используйте сторонние приложения, чтобы упростить рабочие процессы.",
      "clipsTitle": "Пользовательские аватары для Zoom Clips",
      "clipsDesc": "Разрешите пользователям персонализировать ИИ-аватары для своих клипов."
    },
    "coachMark": {
      "licenseTitle": "У вас есть {0} лицензий Custom AI Companion для назначения",
      "licenseDesc": "Назначьте эти лицензии в разделе <b>Управление пользователями</b>, чтобы пользователи могли начать использовать расширенные возможности AI Companion.",
      "settingTitle": "Просмотрите настройки Custom AI Companion для вашей учетной записи",
      "settingDesc": "Настройте параметры каждой функции Custom AI в разделе <b>Настройки учетной записи</b>. <a href=\"/account/setting?tab=aicompanion\">Перейти к настройкам</a>",
      "groupSettingTitle": "Просмотрите настройки Custom AI для вашей группы",
      "groupSettingDesc": "Настройте параметры каждой функции Custom AI в разделе <b>Настройки группы</b>. <a href=\"/account/group\">Перейти к настройкам</a>"
    },
    "common": {
      "learnMore": "Подробнее",
      "quickTour": "Пройти краткий обзор",
      "remindLater": "Напомнить позже",
      "dismiss": "Закрыть",
      "next": "Далее",
      "back": "Назад",
      "gotIt": "Понятно",
      "goToSetting": "Перейти к настройкам"
    },
    "aiPanelToast": "Включите параметр <b>Панель ИИ в Zoom Workplace</b>, чтобы начать использовать все функции Custom AI Companion."
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "Понятно",
      "next": "Далее",
      "remindMeLater": "Напомнить позже",
      "waffleMenuTitle": "Добро пожаловать в новый веб-интерфейс Zoom",
      "waffleMenuDesc": "Получайте доступ к продуктам Zoom из любого места с помощью нового <b>меню продуктов.</b>",
      "profileMenuTitle": "Моя учетная запись",
      "profileMenuDesc": "Найдите свой профиль и личные настройки в разделе <b>Моя учетная запись.</b>",
      "personalTitle": "Доступ ко всему необходимому",
      "personalDesc": "В разделе <b>Моя учетная запись</b> находятся ваш профиль, настройки, расшифровки конференций и многое другое.",
      "adminCenterTitle": "Настройки организации в Центре администрирования",
      "adminCenterDesc": "Новый <b>Центр администрирования</b> позволяет настраивать продукты и изменять параметры для всей организации.",
      "adminMenuForTitle": "Используйте Центр администрирования как профессионал",
      "adminMenuForAccountSettings": "В разделе <b>Настройки</b> доступны стандартные параметры продуктов для всех в вашей организации.",
      "adminMenuForContentManagementItem": "В разделе <b>Управление контентом</b> можно управлять всем пользовательским контентом.",
      "adminMenuForConfigureProductsItem": "В разделе <b>Конфигурация продуктов</b> можно настраивать продукты и выполнять задачи администратора.",
      "adminMenuForNoItems": "Новый центр администрирования позволяет проще получать доступ к настройкам учетной записи и продуктам и управлять ими. Вы также можете закрепить любые элементы для быстрого доступа.",
      "tryNewExperience": "Попробовать новый интерфейс",
      "tryNewExperienceDetail": "Попробуйте! Вы всегда можете вернуться к классическому интерфейсу.",
      "tryNewExperienceTitle": "Новый внешний вид Zoom Web!"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. Все права защищены.",
    "terms": "Условия",
    "privacy": "Конфиденциальность",
    "trust_center": "Центр доверия",
    "acceptable_use_guidelines": "Рекомендации по допустимому использованию",
    "legal": "Юридическая информация",
    "do_not_sell_my_personal_information": "Ваши настройки конфиденциальности",
    "cookie_preferences": "Настройки файлов cookie",
    "pricing": "Планы и цены",
    "feedback": "Обратная связь",
    "contact_us": "Связаться с нами"
  },
  "termChange": {
    "changeTerm": {
      "title": "Соглашение об изменении срока продления",
      "quoteNumbers": "Измененная форма(ы) заказа — {0}",
      "content1": "Принимая настоящие условия, Заказчик соглашается изменить существующий срок продления подписки для всех форм заказа между Zoom Communications, Inc. («Zoom») и Заказчиком, заменив обязательный срок с помесячного продления на {0}. В обмен на это обязательство Zoom соглашается сохранить текущие цены Заказчика на протяжении первого нового срока продления.",
      "content2": "Заказчик понимает, что новый срок продления {0} применяется с момента нажатия Заказчиком кнопки «Я принимаю» ниже и что новый срок продления начинается на следующий день после окончания текущего помесячного срока продления Заказчика. Этот новый срок продления применяется ко всем формам заказа, действующим в настоящее время с Zoom, и все будущие сроки продления по этим формам заказа будут иметь ту же продолжительность.",
      "content3": "Заказчик подтверждает, что единственным изменением является срок продления и что все остальные условия каждой формы заказа, действующей в настоящее время с Zoom, остаются без изменений и полностью сохраняют силу в соответствии с их положениями.",
      "content4": "Вы также соглашаетесь, что это является договорным обязательством между Заказчиком и Zoom.",
      "agreementText": "Нажимая «Я принимаю», вы подтверждаете, что уполномочены внести это изменение от имени Заказчика и что Заказчик соглашается с условиями, изложенными выше.",
      "IDecline": "Я отклоняю",
      "IAccept": "Я принимаю"
    },
    "unableToChangeTerm": {
      "title": "Не удалось изменить срок продления",
      "content": "Ваша учетная запись не имеет права на обновление срока продления. <a target=\"_blank\" href=\"{0}\">Свяжитесь с нами</a>, если это ошибка.",
      "acceptedTitle": "Срок продления увеличен",
      "acceptedContent": "Вы уже приняли условия продления. Дальнейшие действия не требуются.",
      "GotIt": "Понятно"
    },
    "termLengthUpdated": "Срок продления обновлен до {0} мес.",
    "termLengthUnchanged": "Срок не изменен.",
    "errorInfo": "Произошла ошибка сервера. Повторите попытку.",
    "x12MonthTerm": "срок в двенадцать (12) месяцев",
    "x24MonthTerm": "срок в двадцать четыре (24) месяца",
    "x12MonthTermPlural": "двенадцать (12) месяцев",
    "x24MonthTermPlural": "двадцать четыре (24) месяца"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "Учетная запись будет обновлена до <a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">нового веб-интерфейса Zoom</a> {0}.",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">Проверить дату обновления</a>"
    },
    "completed": {
      "content": "Новый веб-интерфейс Zoom теперь активен для всех пользователей учетной записи. Обновленный интерфейс появится при следующем входе."
    }
  }
}
